import React, { useCallback, useState } from 'react';

import { Button, Col, Input, Modal, Row, Switch, Typography } from 'antd';

import { useUserStore } from 'v2/store/User';

import LinksClipBoard from './LinksClipBoard';

interface IProps {
  open: boolean;
  handleClose: () => void;
  baseUrl: string;
  baseUrlChk?: string;
  isProducer?: boolean;
}

const UrlCreator: React.FC<IProps> = ({ open, handleClose, baseUrl, baseUrlChk, isProducer }) => {
  const [utmSource, setUtmSource] = useState('');
  const [utmMedium, setUtmMedium] = useState('');
  const [utmContent, setUtmContent] = useState('');
  const [utmCampaign, setUtmCampaign] = useState('');
  const [redirect, setRedirect] = useState(false);

  const { currentUserId } = useUserStore(({ user }) => ({ currentUserId: user.id }));

  const createParameters = useCallback(
    (baseUrlParam: string) => {
      const parameters: string[] = [];
      let firstParameter = '?';

      if (utmSource) {
        parameters.push('utm_source=' + utmSource);
      }

      if (utmMedium) {
        parameters.push('utm_medium=' + utmMedium);
      }

      if (utmContent) {
        parameters.push('utm_content=' + utmContent);
      }

      if (utmCampaign) {
        parameters.push('utm_campaign=' + utmCampaign);
      }

      if (redirect) {
        parameters.push('redirecionar=S');
      }

      if (!isProducer) {
        parameters.push('a=' + currentUserId);
      }

      if (parameters.length === 0) {
        return '';
      }

      if (baseUrlParam.indexOf('a=') >= 0) {
        firstParameter = '&';
      }

      return firstParameter + parameters.join('&');
    },
    [utmSource, utmMedium, utmContent, utmCampaign, redirect, isProducer, currentUserId]
  );

  const urlsCheckouts = {
    urlChk: baseUrlChk ? baseUrlChk + createParameters(baseUrlChk) : '',
    urlSun: baseUrl + createParameters(baseUrl)
  };

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      title={<span style={{ color: '#192542' }}>Adicionar UTM&apos;s</span>}
      width='95vw'
      style={{ maxWidth: 900 }}
      footer={
        <div className='flex justify-end'>
          <Button type='primary' size='large' onClick={handleClose}>
            Fechar
          </Button>
        </div>
      }
    >
      <Typography.Text style={{ color: '#818B9D' }}>Crie sua URL para rastrear melhor seus resultados.</Typography.Text>
      <Row gutter={[16, 16]}>
        <Col md={12} xs={24}>
          <label className='mb-1 block text-sm'>Origem da campanha ( utm_source )</label>
          <Input value={utmSource} onChange={(e: any) => setUtmSource(e.target.value)} />
          <span className='text-xs text-gray-500'>Ex: google, facebook, newsletter</span>
        </Col>
        <Col md={12} xs={24}>
          <label className='mb-1 block text-sm'>Mídia da campanha ( utm_medium )</label>
          <Input value={utmMedium} onChange={(e: any) => setUtmMedium(e.target.value)} />
          <span className='text-xs text-gray-500'>Ex: mídia de marketing: cpc, banner, e-mail</span>
        </Col>
        <Col md={12} xs={24}>
          <label className='mb-1 block text-sm'>Conteúdo da campanha ( utm_content )</label>
          <Input value={utmContent} onChange={(e: any) => setUtmContent(e.target.value)} />
          <span className='text-xs text-gray-500'>Ex: bannerPromocao, bannerBonus</span>
        </Col>
        <Col md={12} xs={24}>
          <label className='mb-1 block text-sm'>Origem da campanha ( utm_campaign )</label>
          <Input value={utmCampaign} onChange={(e: any) => setUtmCampaign(e.target.value)} />
          <span className='text-xs text-gray-500'>Ex: CampanhaDeLancamento</span>
        </Col>
        <Col span={24}>
          <div className='flex items-center gap-2'>
            <Switch checked={redirect} onChange={(checked: boolean) => setRedirect(checked)} />
            <span>Encaminhar UTMs do link para a URL do produtor</span>
          </div>
        </Col>

        <LinksClipBoard urlChk={urlsCheckouts.urlChk} urlSun={urlsCheckouts.urlSun} />
      </Row>
    </Modal>
  );
};

export default UrlCreator;
